export const navItems = [
  {
    name: 'Dashboard',
    path: '/dashboard',
    class: 'arz-home2',
    inactiveIcon: 'dashboard_inactive.png',
    activeIcon: 'dashboard_active.png',
    icon: '/images/dashboardSidebar.svg',
  },
  // {
  //   name: 'Analytics',
  //   path: '/analytics',
  //   class: 'arz-stats-dots',
  //   inactiveIcon: 'dashboard_inactive.png',
  //   activeIcon: 'dashboard_active.png',
  //   icon: '/images/analyticsSidebar.svg',
  // },
  {
    // showAdmin: true,
    name: 'Catalogue',
    path: '/catalogue',
    class: 'arz-books',
    inactiveIcon: 'inventory_white.png',
    activeIcon: 'inventory_active.png',
    icon: '/images/catalogueSidebar.svg',
  },
  {
    name: 'GRN Dashboard',
    path: '/grn',
    // class: 'arz-stats-dots',
    inactiveIcon: 'GRN_inactive.svg',
    activeIcon: 'GRN_active.svg',
    icon: '/images/GRN_theme.svg',
  },
  {
    // showAdmin: true,
    name: 'Orders',
    path: '/my-orders',
    class: 'arz-cart',
    inactiveIcon: 'sent_inactive.png',
    activeIcon: 'sent_active.png',
    icon: '/images/cartSidebar.svg',
  },
  {
    new: true,
    // showAdmin: true,
    name: 'Accounts Statement',
    path: '/account-statement',
    class: 'arz-credit-card',
    inactiveIcon: 'payment_inactive.png',
    activeIcon: 'payment_active.png',
    icon: '/images/paymentsSidebar.svg',
  },
  {
    // new: true,
    name: 'Price Auction',
    path: '/reverse-auction',
    class: 'arz-fire',
    icon: '/images/auctionSidebar.svg',
  },
  // {
  //   name: 'Payment Ledger',
  //   path: '/payments-history',
  //   class: 'arz-credit-card',
  //   inactiveIcon: 'payment_inactive.png',
  //   activeIcon: 'payment_active.png',
  //   icon: '/images/paymentsSidebar.svg',
  // },
  {
    // new: true,
    name: 'Bulk Deals',
    path: '/bulk-deals',
    class: 'arz-announcement',
    icon: '/images/bulkDealsSidebar.svg',
  },
  {
    name: 'IRN Addition',
    path: '/nic-credentials',
    class: 'arz-credit-card',
    inactiveIcon: 'payment_inactive.png',
    activeIcon: 'payment_active.png',
    icon: '/images/apiCredentialSidebar.svg',
  },
  {
    // showAdmin: true,
    name: 'Profile',
    path: '/vendor-details',
    class: 'arz-profile',
    inactiveIcon: 'profile_inactive.png',
    activeIcon: 'profile_active.png',
    icon: '/images/profileSidebar.svg',
  },
  // {
  //   name: 'Deals',
  //   path: '/deals-request',
  //   class: 'arz-bullhorn',
  //   inactiveIcon: 'discount-white.png',
  //   activeIcon: 'discount.png',
  // },
  // {
  //   name: 'Reverse Auction',
  //   path: '/reverse-auction',
  //   class: 'arz-fire',
  // },
  // {
  //   name: 'Orders Passbook',
  //   path: '/payments',
  //   class: 'arz-credit-card',
  //   inactiveIcon: 'payment_inactive.png',
  //   activeIcon: 'payment_active.png',
  //   icon: '/images/paymentsSidebar.svg',
  // },
];

export const pilotNavItems = [
  ...navItems,
  {
    name: 'IRN Addition',
    path: '/nic-credentials',
    class: 'arz-credit-card',
    inactiveIcon: 'payment_inactive.png',
    activeIcon: 'payment_active.png',
  },
];

export const PHONE_PREFIX = '+91';
export const SUPPORT_PHONE = '8068001104';
export const SUPPORT_TIMEING = '10AM - 7PM';
export const SUPPORT_AVAILBILITY = '365 days';
export const SUPPORT_EMAIL = 'sellersupport@arzooo.com';
